import FPVue from "../FP.vue";
import serviceErrorHandling from "../mixins/serviceErrorHandling";
import { noticeService, Notice } from "../services";

type NoticeWithEdits = Notice & {
  isEditing: boolean;
  editDescription: string | undefined;
  editTitle: string | undefined;
  editImportant: boolean;
};

export default FPVue.extend({
  name: "al-notices",
  mixins: [serviceErrorHandling],
  data: function() {
    return {
      newNotice: { important: false } as Notice,
      notices: [] as NoticeWithEdits[],
      rules: {
        required: (value: any) => !!value || "Required."
      },
      apiKey: "" as string | null,
      apiKeyConfirmed: false,
      deletedNotice: {} as Notice,
      simpleDisplay: true, // no edit functionality,
      deleteDialog: {
        show: false,
        index: -1
      }
    };
  },
  computed: {},
  methods: {
    onSubmit(e: Event) {
      e.preventDefault();
    },
    getDate(n: Notice) {
      var lastDate = n.updated ? n.updated : n.created;

      return lastDate?.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    openDeleteDialog(index: number) {
      this.deleteDialog.index = index;
      this.deleteDialog.show = true;
    },

    closeDeleteDialog() {
      this.deleteDialog.show = false;
      this.deleteDialog.index = -1;
    },

    confirmDelete() {
      const i = this.deleteDialog.index;
      if (i >= 0) {
        this.deleteNotice(i);
      }
      this.closeDeleteDialog();
    },

    // Add new notice
    async addNotice() {
      if (!this.newNotice.title || !this.newNotice.description) return;

      if (!this.apiKey?.length) {
        this.inlineMessage.message = "Must provide API key.";
        this.inlineMessage.type = "error";
        return;
      }

      this.processing = true;
      try {
        await noticeService.addNotice(this.newNotice, this.apiKey!);
        this.newNotice.title = "";
        this.newNotice.description = "";
        this.newNotice.important = false;
        this.loadNotices();
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    },

    enableEdit(index: number) {
      const n = this.notices[index];
      n.isEditing = true;
      n.editTitle = n.title;
      n.editDescription = n.description;
      n.editImportant = n.important ?? false;
    },

    cancelEdit(index: number) {
      const n = this.notices[index];
      n.isEditing = false;
    },

    // Save notice changes
    async saveNotice(index: number) {
      const n = this.notices[index];

      if (!this.apiKey?.length) {
        this.inlineMessage.message = "Must provide API key.";
        this.inlineMessage.type = "error";
        return;
      }

      this.processing = true;
      try {
        n.title = n.editTitle;
        n.description = n.editDescription;
        n.important = n.editImportant;
        await noticeService.updateNotice(n, this.apiKey!);
        n.isEditing = false;
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    },

    // Delete a notice
    async deleteNotice(index: number) {
      const n = this.notices[index];

      if (!this.apiKey?.length) {
        this.inlineMessage.message = "Must provide API key.";
        this.inlineMessage.type = "error";
        return;
      }

      this.processing = true;
      try {
        await noticeService.archiveNotice(n, this.apiKey!);
        this.deletedNotice = n;
        this.notices.splice(index, 1);
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    },

    async loadNotices() {
      this.inlineMessage.message = null;

      if (!this.apiKey?.length) {
        this.inlineMessage.message = "Must provide API key.";
        this.inlineMessage.type = "error";
        return;
      }

      this.processing = true;
      try {
        var loadedNotices = await noticeService.getAllNotices(this.apiKey!);
        this.apiKeyConfirmed = true;
        this.notices =
          loadedNotices
            ?.filter(x => x.archivedDate == null)
            .map(
              x =>
                ({
                  ...x,
                  isEditing: false,
                  editDescription: undefined,
                  editTitle: undefined,
                  editImportant: x.important
                } as NoticeWithEdits)
            ) ?? [];
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    }
  },
  created: async function() {}
});

